import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';
// Importação do Router
import { Redirect, Link } from 'react-router-dom';

import Overlay from '../Miscelania/Overlay';

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      username: '',
      password: '',
      mensagem: null,
      forget_password: false,
    };
    // Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.login = this.login.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidUpdate(prevProps, prevState) {
    this.handleMessage();
  }


  login(event) {
    event.preventDefault();
    var headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    };
    var datasave = {
      username: this.state.username,
      password: this.state.password,
      system: 'sigmec',
    };
    this.handleAlert('', '', 'open');
    fetch(config.get('api') + '/get/token', { method: 'POST', mode: 'cors', headers: headers, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
      this.refs.request_api.validate(responseJson);
      if (responseJson.error === 'inexistent_user') {
        this.handleAlert('Usuário não cadastrato. Solicite a TI a criação do usuário.', 'error', 'open');
      } else if (responseJson.error === 'inactive_user') {
        this.handleAlert('Usuário inativo neste sistema. Solicite a TI a liberação do usuário.', 'error', 'open');
      } else if (responseJson.error === 'permissionless_user') {
        this.handleAlert('Usuário sem permissões para este sistema. Solicite a TI as permissões de acesso para este usuário.', 'error', 'open');
      } else if (responseJson.error === 'invalid_credentials' || responseJson.error === 'invalid_request' || responseJson.data.token === '{"error":"invalid_credentials","message":"The user credentials were incorrect."}') {
        this.handleAlert('Usuário ou senha inválidos.', 'error', 'open');
      } else {
        var now = new Date();
        var now_date = now.toISOString().slice(0,10);
        var now_hr = now.toISOString().slice(11,19);
        var now = now_date + ' ' + now_hr;
        var token = JSON.parse(responseJson.data.token);
        var storage = {
          rcode: token.refresh_token,
          acode: token.access_token,
          system: 'sigmec',
          last_update: now,
        };
        localStorage.setItem("cid", JSON.stringify(storage));
        var data = {
          email: this.state.username,
        };
        localStorage.setItem("data", JSON.stringify(data));
        var url = responseJson.data.redirect.sigmec;
        if (url === null) {
          url = '/';
        }
        this.setState({redirect_url: url});
      }
    }).catch((error) => {
      console.error(error);
    });
  }

  render() {
    return (
<div>
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <RequestApi ref={'request_api'} />
  <div className="hidden-xs hidden-sm hidden-md user-wrapper" style={{backgroundImage: "url('" + config.get('cdn') + "/images/modal_background.png'), url('" + config.get('cdn') + "/images/fundo-login.jpg')"}}>
    <div className="user-layer">
      <div className="container">
        <div className="row">
          <div className="col-md-4 col-md-offset-4">
            <div className="user-content text-center">
              <img src={config.get('cdn') + '/images/logo2.png'} alt="SIGTREIN" />
              <form onSubmit={this.login}>
                <div className="form-group">
                  <div className="input-group">
                    <div className="input-group-addon"><i className="fa fa-fw fa-at"></i></div>
                    <input type="text" name="username" className="form-control" placeholder="Seu e-mail" value={this.state.username} onChange={this.handleChange.bind(this, 'username')} />
                  </div>
                </div>
                <div className="form-group">
                  <div className="input-group">
                    <div className="input-group-addon"><i className="fa fa-fw fa-lock"></i></div>
                    <input type="password" name="password" className="form-control" placeholder="Sua senha" value={this.state.password} onChange={this.handleChange.bind(this, 'password')} />
                  </div>
                </div>
                {
                  config.get('development') &&
                  <p className="bg-danger"><i className="fa fa fa-warning"></i><span style={{color: 'red'}}> ATENÇÃO: VOCÊ ACESSARÁ O AMBIENTE DE HOMOLOGAÇÃO </span><i className="fa fa fa-warning"></i></p>
                }
                <button className="btn btn-success btn-block" type="submit"><i className="fa fa-fw fa-sign-in"></i> Acessar o sistema</button>
              </form>
              <p className="bg-primary">O LOGIN DEVE SER FEITO COM O USUÁRIO E SENHA OMNI/RUBI</p>
              <div className="row">
                <div className="col-md-5">
                  <p className="versao-login">v1.1.5 - 22/08/2019</p>
                </div>
                <div className="col-md-7">
                  <p className="text-right"><span onClick={() => {this.setState({ forget_password: true })} } className="link-recuperar-senha">Esqueci minha senha</span></p>
                </div>
              </div>
              {this.state.forget_password ? <span className="label label-danger">Para recuperar sua senha, entre em contato com o setor de TI.</span> : ''}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="user-wrapper visible-xs-block visible-sm-block visible-md-block" style={{backgroundImage: "url('" + config.get('cdn') + "/images/modal_background.png')"}}>
    <div className="user-layer">
      <div className="container">
        <div className="row">
          <div className="col-md-4 col-md-offset-4">
            <div className="user-content text-center">
              <img src={config.get('cdn') + '/images/logo2.png'} alt="SIGTREIN" />
              <form onSubmit={this.login}>
                <div className="form-group">
                  <div className="input-group">
                    <div className="input-group-addon"><i className="fa fa-fw fa-at"></i></div>
                    <input type="text" name="username" className="form-control" placeholder="Seu e-mail" value={this.state.username} onChange={this.handleChange.bind(this, 'username')} />
                  </div>
                </div>
                <div className="form-group">
                  <div className="input-group">
                    <div className="input-group-addon"><i className="fa fa-fw fa-lock"></i></div>
                    <input type="password" name="password" className="form-control" placeholder="Sua senha" value={this.state.password} onChange={this.handleChange.bind(this, 'password')} />
                  </div>
                </div>
                {
                  config.get('development') &&
                  <p className="bg-danger"><i className="fa fa fa-warning"></i><span style={{color: 'red'}}> ATENÇÃO: VOCÊ ACESSARÁ O AMBIENTE DE HOMOLOGAÇÃO </span><i className="fa fa fa-warning"></i></p>
                }
                <button className="btn btn-success btn-block" type="submit"><i className="fa fa-fw fa-sign-in"></i> Acessar o sistema</button>
              </form>
              <p className="bg-primary">O LOGIN DEVE SER FEITO COM O USUÁRIO E SENHA OMNI/RUBI</p>
              <div className="row">
                <div className="col-md-5">
                  <p className="versao-login">v0.1.12 - 22/06/2017</p>
                </div>
                <div className="col-md-7">
                  <p className="text-right"><span onClick={() => {this.setState({ forget_password: true })} } className="link-recuperar-senha">Esqueci minha senha</span></p>
                </div>
              </div>
              {this.state.forget_password ? <span className="label label-danger">Para recuperar sua senha, entre em contato com o setor de TI.</span> : ''}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/Components/Users/Login.js